<template>
  <i-modal title="分享文件"
           width="595"
           class="cloud-storage-file-share"
           :value="isShowed"
           @on-visible-change="changeHandler">
    <section class="content">
      <div class="l-flex-start">
        <p class="text-mid text-grey-999 l-margin-right-sm">已选择文件</p>
        <div class="l-flex-start">
          <img :src="fileDetail.isImg ? fileDetail.file_thumbnail_url : (fileDetail.isVideo ? (fileDetail.file_snapshot_url || fileType[fileDetail.file_type]) : fileType[fileDetail.file_type])" class="icon icon-w-h-30 border-radius-6">
          <p class="text-lg text-black-000 text-cut width-360">{{fileDetail.file_name}}</p>
        </div>
      </div>
      <section v-if="step === 1" class="step-1">
        <div class="l-flex-start l-margin-top-sm">
          <p class="text-mid text-grey-999">有效期</p>
          <div class="type">
            <i-radio-group size="large" v-model="expiredDays">
              <i-radio label="one">1天</i-radio>
              <i-radio label="senven">7天</i-radio>
            </i-radio-group>
          </div>
        </div>
      </section>
      <section v-if="step === 2" class="step-2">
        <div class="l-flex-start margin-bottom-16">
          <i class="icon-success l-margin-right-xs"></i>
          <p class="text-lg text-black-000 text-center">成功创建分享链接！点击复制链接，分享给朋友。</p>
        </div>
        <div class="l-flex-start">
          <div class="text-mid text-grey-bbb text-cut border-radius-4 line line-color-black-BBBBBB height-40 l-margin-right-xs l-padding-left-sm">{{fileUrl}}</div>
          <i-button type="primary" size="large" class="copy-button" @click="copy(fileUrl)">复制链接</i-button>
        </div>
        <p class="text-mid text-grey-999 l-margin-top-xs">链接有效期：{{expiredDays === 'one' ? 1 : 7}}天</p>
      </section>
    </section>
    <div slot="footer">
      <div class="l-flex-end l-flex-grow-1" v-if="step === 1">
        <i-button type="text" size="large" @click="cancelModel">取消</i-button>
        <i-button type="primary" size="large" @click="confirm">创建链接</i-button>
      </div>
    </div>
  </i-modal>
</template>

<script>

import { Modal, RadioGroup, Radio } from 'iview'
import * as MSG from 'assets/data/message.js'
import api from 'modules/member/api/index.js'
import { FILE_TYPE, PC_ADDRESS } from 'assets/data/constants.js'
import { setImgFlag } from '@/common/js/utils'

export default {
  name: 'FileShare',
  data () {
    return {
      step: 1,
      apiProcessing: false,
      expiredDays: 'one',
      fileDetail: {},
      fileType: FILE_TYPE,
      fileUrl: ''
    }
  },
  watch: {
    // 传入的文件改变，重新获取文件的详细信息
    fileInfo: {
      handler (val) {
        this.init()
      },
      deep: true
    }
  },
  computed: {
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    },
    fileInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  created () {
    this.init()
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  methods: {
    changeHandler (isShowed) {
      this.step = 1
      this.fileUrl = ''
      this.expiredDays = 'one'
      this.$emit('change-show', isShowed)
    },
    cancelModel () {
      this.step = 1
      this.fileUrl = ''
      this.expiredDays = 'one'
      this.$emit('change-show', false) // 关闭弹窗
    },
    async init (cb) {
      // 根目录与文件夹不能分享
      if (this.fileInfo.code && this.fileInfo.file_type !== 'folder') {
        const res = await api.fetchFileDetail({cloud_file_code: this.fileInfo.code})
        if (res) {
          this.fileDetail = res
          setImgFlag(this.fileDetail)
        }
      }
    },
    async confirm () {
      if (this.apiProcessing) {
        this.$store.commit('ADD_MESSAGE', { msg: MSG.GLOBAL_PROCESSING, type: 'error' })
        return false
      }
      this.apiProcessing = true
      // 分享我的文件
      const res = await api.shareFile({
        cloud_file_code: this.fileInfo && this.fileInfo.code ? this.fileInfo.code : '',
        expired_days: this.expiredDays === 'one' ? 1 : 7
      })
      if (res.code === 200) {
        // 进入第2步
        this.step = 2
        // 设置分享的文件的连接
        this.fileUrl = `${PC_ADDRESS}/index.html#/view-shared-file/${this.fileInfo.code}/${res.results.share_log_id}`
      } else {
        this.$store.commit('ADD_MESSAGE', {
          type: 'error',
          msg: '出错了，请重试或取消'
        })
      }
      this.apiProcessing = false
    },
    copy (fileUrl) {
      this.$copyText(fileUrl).then((e) => {
        // copy success
        this.$store.commit('ADD_MESSAGE', {msg: MSG.GLOBAL_COPY_SUCCESS, type: 'success'})
      }, (e) => {
        // copy fail
        console.log(e)
      })
    }
  },
  components: {
    'i-modal': Modal,
    'i-radio': Radio,
    'i-radio-group': RadioGroup
  }
}
</script>

<style lang="stylus">
.cloud-storage-file-share
  .icon-success
    bg-icon(30px, 30px, '../../assets/cloudstorage/icon-success.png')
  .ivu-modal-content .ivu-modal-body
    padding-bottom: 0
  .width-360
    width: 360px
    margin-left: 15px
  .type
    margin-left: 54px
  .ivu-radio-group.ivu-radio-group-large.ivu-radio-large
    &>label
      &:first-child
        margin-right: 102px
  .ivu-radio-large.ivu-radio-wrapper, .ivu-radio-large .ivu-radio-wrapper
    font-size: 18px
  .ivu-radio-large .ivu-radio-inner
    width: 30px
    height: 30px
    margin-right: 14px
  .ivu-radio-large .ivu-radio-inner::after
    width: 22px
    height: 22px
    border-radius: 50%
    top: 3px
    left: 3px
  .height-40
    line-height: 40px
    width: 403px
  .step-1
    margin-bottom: 46px
  .step-2
    margin-top: 48px
  .margin-bottom-16
    margin-bottom: 16px
  .copy-button
    width: 120px
    height: 40px
    font-size: 18px
    & span
      vertical-align: baseline
</style>



// WEBPACK FOOTER //
// src/components/cloudstorage/FileShare.vue